import React, { useEffect, useState } from 'react';
import { collection, getDoc, getDocs, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../../../../../firebase';
import { Button, Modal } from 'react-bootstrap';
import { MdAdd } from 'react-icons/md';
import { format } from 'date-fns';
import { useAuth } from '../../../../../context/AuthContext';
import BookedUnitCount from './booked-unit-count';

const UnitDetails = ({ handleShowUnit, propertyItems, towerID, setSelectedUnit }) => {

  const { user } = useAuth();
  const { bid } = user.claims;

  const [isLoading, setIsLoading] = useState(true);
  const [viewAllUnits, setViewAllUnits] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    const q = query(collection(db, "Businesses", bid, "Properties", propertyItems.id, "Units"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const tempData = [];
      querySnapshot.forEach(async (doc) => {
        if (doc.data().tower.id === towerID) {
          tempData.push({ id: doc.id, ...doc.data() });
        }
      });

      setData(tempData);
    }, (error) => {
      console.log(error.message);
      setIsLoading(false);
    });

    return () => unsubscribe;
  }, []);

  return (
    <div className='border rounded overflow-hidden'>
      <div className='bg-primary-light mb-4 d-flex justify-content-between'>
        <h5 className='mb-0 py-3 px-3'>Units</h5>
        <Button
          variant='none'
          className='bg-primary-light rounded-start-0 border-0'
          onClick={() => setViewAllUnits(true)}
        >
          All Units
        </Button>
      </div>
      {
        data && data.length > 0 ?
          <>
            {
              data && data.map((unit, j) => {
                if (towerID === unit.tower.id) {
                  return (
                    <div key={j} className={j === 0 ? 'row pt-1' : 'row border-top pt-2'}>
                      <div className='col-md-12'>
                        <div className='border rounded d-flex align-items-center justify-content-between mx-3 mb-3'>
                          <div className="py-2 px-3">
                            <span className='form-label'>
                              Unit Name
                            </span>
                            <div>{unit.name}</div>
                          </div>
                          <div className='px-3'>
                            <Button
                              variant='outline-success'
                              size='sm'
                              className='rounded'
                              onClick={() => {
                                handleShowUnit();
                                setSelectedUnit(unit);
                              }}
                            >
                              <span className='small px-1'>EDIT</span>
                            </Button>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-7'>
                        <div className='row'>
                          <div className='col-md-6 col-12 px-3'>
                            <div className="mb-4 px-3">
                              <span className='form-label'>
                                Area per Unit
                              </span>
                              <div>{unit.area} {propertyItems.unitMeasure}</div>
                            </div>
                          </div>
                          <div className='col-md-6 col-12 px-3 text-end'>
                            <div className="mb-3 px-3">
                              <span className='form-label'>
                                Total Floors
                              </span>
                              <div>{unit.numFloors}</div>
                            </div>
                          </div>
                          <div className='col-md-6 col-12 px-3'>
                            <div className="mb-3 px-3">
                              <span className='form-label'>
                                Unit per Floor
                              </span>
                              <div>
                                <span>{unit.numUnitPerFloor} Units</span>
                              </div>
                            </div>
                          </div>
                          <div className='col-md-6 col-12 px-3 text-end'>
                            <div className="mb-3 px-3">
                              <span className='form-label'>
                                Unit Numbers
                              </span>
                              <div>
                                <span className='ms-2'>
                                  ({
                                    unit.unitNumberPerFloor && unit.unitNumberPerFloor.map((unpf, j) => {
                                      return (
                                        <small key={j}>{`${j !== 0 ? ", " : ''}P${unpf.number}`}</small>
                                      )
                                    })
                                  })
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-5 mb-3 mt-2'>
                        <div className='bg-light h-100 mx-3 rounded'>
                          <div className="mb-3 px-3 text-center border rounded h-100">
                            <div className='h-100 mb-3 d-flex align-items-center justify-content-center'>
                              <div className='border-end pe-3'>
                                <div className='h5'>{unit.numUnit}</div>
                                <span className='form-label'>
                                  TOTAL UNITS
                                </span>
                              </div>
                              <div className='ps-3'>
                                <div className='h5'>
                                  <BookedUnitCount propID={propertyItems.id} unitID={unit.id} />
                                </div>
                                <span className='form-label'>
                                  BOOKED
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-12 col-12'>
                        <div className="bg-light py-2 px-3">
                          <div className='border-bottom pb-2 mb-2'>
                            <span className='form-label'>
                              Basic Prices
                            </span>
                          </div>
                          {
                            unit.basicPrice && unit.basicPrice.map((price, j) => {
                              return (
                                <div key={j} className='row'>
                                  <div className='col-md-8 col-12 mb-1'>
                                    {price.date && price.date.seconds ? format(new Date(price.date.seconds * 1000), "dd-MM-yyyy") : format(new Date(price.date), "dd-MM-yyyy")}
                                  </div>
                                  <div className='col-md-4 col-12 text-end'>
                                    <span>₹{price.price}{`/${propertyItems && propertyItems.unitMeasure}`}</span>
                                  </div>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                      <div className='col-md-12 col-12'>
                        <div className="bg-light mb-3 py-2 px-3">
                          <div className='border-bottom pb-2 mb-2'>
                            <span className='form-label'>
                              Additional Charges
                            </span>
                          </div>
                          {
                            unit.additionalCharges.map((charge, j) => {
                              return (
                                <div key={j} className='row'>
                                  <div className='col-md-8 col-12 mb-1'>
                                    {charge.name}
                                  </div>
                                  <div className='col-md-4 col-12 text-end'>
                                    {parseFloat(charge.amount).toLocaleString("en-US", { style: "currency", currency: "INR" })}{charge.type === 'per' ? '/' + propertyItems.unitMeasure : null}
                                  </div>
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    </div>
                  )
                }
              })
            }
          </>
          :
          <div className='mx-3 mb-3 mt-2'>
            <Button
              variant='white'
              className='w-100 py-5 border-long-dashed rounded border-0 shadow-none'
              onClick={handleShowUnit}
            >
              <MdAdd size={20} color={`var(--bs-primary)`} />
              <span className='ms-1 text-primary'>New Unit</span>
            </Button>
          </div>
      }

      <Modal
        show={viewAllUnits}
        onHide={() => setViewAllUnits(false)}
        backdrop="static"
        size='xl'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>View All Units</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h2 className='mb-0 text-center py-5'>Coming Soon...</h2>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default UnitDetails;
